import script from "./dxxds_notices.vue?vue&type=script&setup=true&lang=js"
export * from "./dxxds_notices.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__